import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFoundation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .4,
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "path-1-inside-1_1242_28188",
				fill: "white",
				children: /* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M3 4.30769L9 2L15 4.30769V9V14H3V9V4.30769Z"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 2L9.35898 1.06665L9 0.928586L8.64102 1.06665L9 2ZM3 4.30769L2.64102 3.37435L2 3.62089V4.30769H3ZM15 4.30769H16V3.62089L15.359 3.37435L15 4.30769ZM15 14V15H16V14H15ZM3 14H2V15H3V14ZM8.64102 1.06665L2.64102 3.37435L3.35898 5.24104L9.35898 2.93335L8.64102 1.06665ZM15.359 3.37435L9.35898 1.06665L8.64102 2.93335L14.641 5.24104L15.359 3.37435ZM14 4.30769V9H16V4.30769H14ZM14 9V14H16V9H14ZM3 15H15V13H3V15ZM4 14V9H2V14H4ZM4 9V4.30769H2V9H4Z",
				fill: "black",
				mask: "url(#path-1-inside-1_1242_28188)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 3,
				y: 11,
				width: 12,
				height: 4,
				fill: "black"
			})
		]
	})
});
export default SvgFoundation;
